export default __webpack_public_path__ + "static/media/mapp.1e70358c.png";